import { NotificationBar, Container, ContainerGutter, CTA, WhiteSpace, Text } from '@volkswagen-onehub/components-core';
import React from 'react';
import { COLOR_TOKEN } from '../../helpers/color-tokens';

export const NotificationsBar = ({
	notificationBarRef,
	setIsNotificationBarVisible,
}: {
	notificationBarRef: React.RefObject<HTMLDivElement>;
	setIsNotificationBarVisible: (visible: boolean) => void;
}) => {
	const handleNavigateToFeedbackOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event?.preventDefault();

		const targetElement = document.getElementById('opina');

		if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	};

	return (
		<div style={{ background: COLOR_TOKEN.background.notificationBar }} ref={notificationBarRef}>
			<NotificationBar
				data-testid="notification-bar"
				onClose={() => setIsNotificationBarVisible(false)}
				closeButtonLabel="Close notification bar"
			>
				<Container verticalAlign="center" gutter={ContainerGutter.static200} shrinkContent>
					<Text>
						Este espacio es exclusivo para miembros del Club Volkswagen.{' '}
						<CTA
							tag="button"
							emphasis="tertiary"
							aria-label="¿Lo recomendarías?"
							onClick={handleNavigateToFeedbackOnClick}
						>
							<Text whiteSpace={WhiteSpace.nowrap} bold>
								¿Lo recomendarías?
							</Text>
						</CTA>
					</Text>
				</Container>
			</NotificationBar>
		</div>
	);
};
